import React from 'react';
import { Link as NLink } from '../../libs/i18n';
import TouchableItem from './TouchableItem';

export default function Link({ href, ...rest }) {
  if (!href) {
    return <div {...rest} />;
  }
  if (href.indexOf('http') != -1 || href.indexOf('mailto') != -1) {
    return <a href={href} {...rest} />;
  }
  return (
    <TouchableItem>
      <NLink href={href} {...rest} />
    </TouchableItem>
  );
}
